<div id="updatecomponent">
  <mat-tab-group #navTabGroup (selectedTabChange)="onTabChanged($event)">
    @for (tab of tabs; track tab) {
      @if (!tab.count) {
        <mat-tab
          label="{{tab.label}}">
        </mat-tab>
      }
      @if (tab.count) {
        <mat-tab>
          <ng-template mat-tab-label>
            {{tab.label}} @if (tab.count | async) {
            <span class="eca-mat-tab-link-badge">&nbsp;{{tab.count | async}}&nbsp;</span>
          }
        </ng-template>
      </mat-tab>
    }
  }
</mat-tab-group>
<ng-container>
  <router-outlet></router-outlet>

  <div>
    @if (hasUpdatePermission) {
      <button mat-button routerLink="" (click)="logOut()">Logout</button>
    }
  </div>

</ng-container>
</div>